
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useStateValue } from '../../Utils/StateProvider'

import {
    MdOutlineDriveFileRenameOutline,
    MdOutlineDescription,
    MdOutlineClear,
    MdOutlineKeyboardBackspace,
    MdClear,
    MdOutlineAccountBalance
} from 'react-icons/md'
import { AiOutlineNumber } from 'react-icons/ai'
import { BsBank } from 'react-icons/bs'
import { BiSend } from 'react-icons/bi'
import { ImSortAmountDesc } from 'react-icons/im'
import { SiCodenewbie } from 'react-icons/si'
import { FiSend } from 'react-icons/fi'
import { TbArrowBackUp } from 'react-icons/tb'
import { GiKeyLock } from 'react-icons/gi'
import {
    RiNumber0,
    RiNumber1,
    RiNumber2,
    RiNumber3,
    RiNumber4,
    RiNumber5,
    RiNumber6,
    RiNumber7,
    RiNumber8,
    RiNumber9
} from 'react-icons/ri'
import {
    TiFlowSwitch,
    TiFlowParallel,
    TiFlowMerge
} from 'react-icons/ti'

import '../../Styles/Form.css'
import { useCookies } from 'react-cookie'
import Info from '../Info'
import { capitalizeWords, formatToCurrency } from '../../Utils/general'

const Transfer = ({ beneficiary }) => {
    const [{ site, url, customer }, payload] = useStateValue()
    const [transferData, setTransferData] = useState({
        uid: customer?.uid,
        account: customer.account,
        institutions: site.name,
        transaction_type: 'debit',
        domicile: 'intra',
        swift: null,
        routing: null
    })
    const [activeFormPart, setActiveFormPart] = useState(1)
    const [input, setInput] = useState('')
    const [error, setError] = useState(null)
    const [txCodes, setTxCodes] = useState([])
    const [doneCodesCount, setDoneCodesCount] = useState(0)

    const [cookies, removeCookie] = useCookies(['bearerToken'])

    let buttons = [
        <RiNumber0 data-number={0} onClick={e => setInput(`${input}0`)} />,
        <RiNumber1 data-number={1} onClick={e => setInput(`${input}1`)} />,
        <RiNumber2 data-number={2} onClick={e => setInput(`${input}2`)} />,
        <RiNumber3 data-number={3} onClick={e => setInput(`${input}3`)} />,
        <RiNumber4 data-number={4} onClick={e => setInput(`${input}4`)} />,
        <RiNumber5 data-number={5} onClick={e => setInput(`${input}5`)} />,
        <RiNumber6 data-number={6} onClick={e => setInput(`${input}6`)} />,
        <RiNumber7 data-number={7} onClick={e => setInput(`${input}7`)} />,
        <RiNumber8 data-number={8} onClick={e => setInput(`${input}8`)} />,
        <RiNumber9 data-number={9} onClick={e => setInput(`${input}9`)} />

    ]

    const clearForm = () => {
        setTransferData({
            uid: customer?.uid,
            account: customer.account,
            transaction_type: 'debit',
            domicile: 'intra',
            swift: null,
            routing: null
        })
        setActiveFormPart(1)
    }

    const handleSuspension = async () => {
        // check if flag_on_tx is activated
        if (customer?.flag_on_tx && parseInt(customer?.flag_on_tx) > 0) {
            // suspend account if activated and logout user
            await axios.patch(`${url}/api/u/`, { setters: { suspend: 1 }, validators: { uid: customer?.uid } }, {
                headers: {
                    Authorization: `Bearer ${cookies?.bearerToken}`
                }
            })

            // log user out
            await axios.patch(`${url}/api/u/auth`, {}, {
                headers: {
                    Authorization: `Bearer ${cookies?.bearerToken}`
                }
            })
            removeCookie('bearerToken')
            removeCookie('uid')
            removeCookie('alive')
            localStorage.removeItem('customer')
            payload({
                type: 'TOGGLE_HEADER',
                state: true
            })
        }
    }

    const goForward = async () => {
        setError(null)
        const options = {
            headers: {
                Authorization: `Bearer ${cookies.bearerToken}`
            }
        }
        switch (activeFormPart) {
            case 1:
                if (
                    !transferData.account ||
                    !transferData.account_name ||
                    !transferData.account_number ||
                    !transferData.amount ||
                    !transferData.description ||
                    !transferData.domicile
                ) return setError('Missing required parameter(s).')

                if (
                    transferData.domicile !== 'intra' &&
                    !transferData.institutions
                ) return setError(`Please provide financial institution (Receiver's bank) to receive this payment`)

                if (
                    transferData.account_number !== transferData.c_account_number
                ) return setError(`Account number did not match.`)

                try {
                    payload({
                        type: 'TOGGLE_PROCESSING_DASH',
                        state: true
                    })
                    let user = await axios.get(`${url}/api/u?uid=${customer.uid}`, options)
                    user = user.data.data

                    if (((user.balance + user.ledger_balance) - transferData.amount) <= 0) return setError('Insufficient balance')

                } catch (err) {
                    return setError(err.response.data.message)
                } finally {
                    payload({
                        type: 'TOGGLE_PROCESSING_DASH',
                        state: false
                    })
                }

                setActiveFormPart(2)
                break;
            case 2:
                if (!input) return setError('Please provide your account secure PIN to proceed with this request.')
                if (input.toString() !== customer.secure_pin) return setError('Invalid secure PIN provided')

                try {
                    // check if receiver in approved payee list
                    payload({
                        type: 'TOGGLE_PROCESSING_DASH',
                        state: true
                    })

                    const res = await axios.all([
                        axios.get(`${url}/api/u/payee?uid=${customer.uid}&account_number=${transferData.account_number}`, options),
                        axios.get(`${url}/api/u/codes`, options)
                    ])

                    let [payees, codes] = res

                    payees = payees.data.approvedPayee
                    codes = codes.data.codes

                    if (payees.length > 0)
                        if (transferData.amount > payees.allowed_limit) return setError(`Exceeded the allowed transaction limit for this beneficiary. Reduce value and try again.`)

                    if (codes.length <= 0) {
                        const txData = {
                            uid: customer.uid,
                            transaction_type: transferData.transaction_type,
                            description: transferData.description,
                            account_number: transferData.account_number,
                            account_name: transferData.account_name,
                            institutions: transferData.institutions,
                            swift: transferData.swift,
                            routing: transferData.routing,
                            domicile: transferData.domicile,
                            amount: transferData.amount,
                            status: 1,
                            secure_pin: customer.secure_pin
                        }
                        await axios.post(`${url}/api/tx`, txData, options)

                        setActiveFormPart(1)
                        setTransferData({
                            uid: customer?.uid,
                            account: customer.account,
                            institutions: site.name,
                            transaction_type: 'debit',
                            domicile: 'intra',
                            swift: null,
                            routing: null
                        })
                        setInput('')
                        payload({
                            type: 'SET_NOTIFY',
                            data: {
                                text: `You have successfully sent the sum of ${formatToCurrency(transferData?.amount, customer?.currency)} to ${capitalizeWords(transferData?.account_name)}. Track transaction progress from your transaction history dashboard.`,
                                type: 'success'
                            }
                        })
                        await handleSuspension()
                        return
                    } else {
                        setTxCodes(codes)
                    }
                } catch (err) {
                    return setError(err.response.data.message)
                } finally {
                    payload({
                        type: 'TOGGLE_PROCESSING_DASH',
                        state: false
                    })
                }
                setInput('')
                setActiveFormPart(3)
                break;

            default:
                if (txCodes.length > 0) {

                    if (txCodes[doneCodesCount].code.toString() !== input.toString()) return setError('Invalid code provided.')

                    if (doneCodesCount >= txCodes.length - 1) try {
                        payload({
                            type: 'TOGGLE_PROCESSING_DASH',
                            state: true
                        })

                        const txData = {
                            uid: customer.uid,
                            transaction_type: transferData.transaction_type,
                            description: transferData.description,
                            account_number: transferData.account_number,
                            account_name: transferData.account_name,
                            institutions: transferData.institutions,
                            swift: transferData.swift,
                            routing: transferData.routing,
                            domicile: transferData.domicile,
                            amount: transferData.amount,
                            status: 1,
                            secure_pin: customer.secure_pin
                        }
                        await axios.post(`${url}/api/tx`, txData, options)
                        await handleSuspension()

                        setActiveFormPart(1)
                        setTransferData({
                            uid: customer?.uid,
                            account: customer.account,
                            institutions: site.name,
                            transaction_type: 'debit',
                            domicile: 'intra',
                            swift: null,
                            routing: null
                        })
                        setInput('')
                        payload({
                            type: 'SET_NOTIFY',
                            data: {
                                text: `You have successfully sent the sum of ${formatToCurrency(transferData?.amount, customer?.currency)} to ${capitalizeWords(transferData?.account_name)}. Track transaction progress from your transaction history dashboard.`,
                                type: 'success'
                            }
                        })
                    } catch (err) {
                        setError(err.response.data.message)
                    } finally {
                            payload({
                                type: 'TOGGLE_PROCESSING_DASH',
                                state: false
                            })
                        }
                    else {
                        setDoneCodesCount(doneCodesCount + 1)
                        setActiveFormPart(activeFormPart + 1)
                    }

                    setInput('')
                }
                else
                    setActiveFormPart(1)
        }
    }

    useEffect(() => {
        if (transferData.domicile === 'intra') setTransferData({ ...transferData, institutions: site.name })
        else
            if (transferData.domicile === 'international')
                setTransferData({ ...transferData, institutions: beneficiary ? beneficiary.institution : '', swift: '', routing: '' })
            else
                setTransferData({ ...transferData, institutions: beneficiary ? beneficiary.institution : '', swift: null, routing: null })

    }, [transferData.domicile])

    useEffect(() => {
        if (beneficiary) setTransferData({
            uid: customer?.uid,
            account: customer.account,
            account_name: beneficiary.account_name,
            account_number: beneficiary.account_number,
            c_account_number: beneficiary.account_number,
            institutions: beneficiary.institution,
            transaction_type: 'debit',
            domicile: beneficiary.domicile,
            swift: beneficiary.swift,
            routing: beneficiary.routing
        })
    }, [beneficiary])


    return (
        <div className='display transfer'>
            <div className="transfer-form">
                <form className='default'>
                    {
                        error && (
                            <div className="error-box">{error}</div>
                        )
                    }
                    {
                        activeFormPart === 1 && (
                            <div className='form-part'>
                                <h1>Send From</h1>
                                <div className="form-row split-row">
                                    <div className="input-row select-input">
                                        <label htmlFor="account">Select Account</label>
                                        <select
                                            name="account"
                                            id="account"
                                            className="bold"
                                            onChange={e => setTransferData({ ...transferData, account: e.target.value })}
                                            required
                                        >
                                            <option value={customer?.account}>{customer?.account}</option>
                                        </select>
                                        <MdOutlineAccountBalance />
                                    </div>
                                    <div className="input-row"></div>
                                </div>
                                <div className="form-row">
                                    <div className="type-selector">
                                        <label htmlFor="account">Transaction Type</label>
                                        <div className="types">
                                            <div
                                                className={transferData.domicile === "intra" ? "type active" : "type"}
                                                onClick={() => document.getElementById('intra').click()}
                                            >
                                                <input
                                                    type="radio"
                                                    name="domicile"
                                                    id="intra"
                                                    value="intra"
                                                    hidden="hidden"
                                                    defaultChecked
                                                    onChange={e => setTransferData({ ...transferData, domicile: e.target.value })}
                                                />
                                                Intra Bank Transfer <TiFlowParallel />
                                            </div>
                                            <div
                                                className={transferData.domicile === "local" ? "type active" : "type"}
                                                onClick={() => document.getElementById('local').click()}
                                            >
                                                <input
                                                    type="radio"
                                                    name="domicile"
                                                    id="local"
                                                    value="local"
                                                    hidden="hidden"
                                                    onChange={e => setTransferData({ ...transferData, domicile: e.target.value })}
                                                />
                                                Local Banks Transfer <TiFlowMerge />
                                            </div>
                                            <div
                                                className={transferData.domicile === "international" ? "type active" : "type"}
                                                onClick={() => document.getElementById('international').click()}
                                            >
                                                <input
                                                    type="radio"
                                                    name="domicile"
                                                    id="international"
                                                    value="international"
                                                    hidden="hidden"
                                                    onChange={e => setTransferData({ ...transferData, domicile: e.target.value })}
                                                />
                                                International Banks Transfer <TiFlowSwitch />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h1>Receiver's Details</h1>
                                <div className="form-row split-row">
                                    <div className="input-row">
                                        <input
                                            type="text"
                                            name="account_name"
                                            value={transferData?.account_name}
                                            onChange={e => setTransferData({ ...transferData, account_name: e.target.value })}
                                            required
                                        />
                                        <label htmlFor="account_name">Account Name (Full name)</label>
                                        <MdOutlineDriveFileRenameOutline />
                                    </div>
                                    <div className="input-row"></div>
                                </div>
                                <div className="form-row split-row">
                                    <div className="input-row">
                                        <input
                                            type="text"
                                            name="account_number"
                                            value={transferData?.account_number}
                                            onChange={e => setTransferData({ ...transferData, account_number: e.target.value })}
                                            required
                                        />
                                        <label htmlFor="account_name">Account Number</label>
                                        <AiOutlineNumber />
                                    </div>
                                    <div className="input-row">
                                        <input
                                            type="text"
                                            name="c_account_number"
                                            value={transferData?.c_account_number}
                                            onChange={e => setTransferData({ ...transferData, c_account_number: e.target.value })}
                                            required
                                        />
                                        <label htmlFor="c_account_number">Confirm Account Number</label>
                                        <AiOutlineNumber />
                                    </div>
                                </div>
                                {
                                    transferData.domicile !== 'intra' && (
                                        <div className="form-row">
                                            <div className="input-row">
                                                <input
                                                    type="text"
                                                    name="institutions"
                                                    value={transferData?.institutions}
                                                    onChange={e => setTransferData({ ...transferData, institutions: e.target.value })}
                                                    required
                                                />
                                                <label htmlFor="institutions">Receiving Bank</label>
                                                <BsBank />
                                            </div>
                                        </div>
                                    )
                                }
                                <div className="form-row split-row">
                                    <div className="input-row">
                                        <input
                                            type="text"
                                            name="amount"
                                            value={transferData?.amount}
                                            onChange={e => setTransferData({ ...transferData, amount: e.target.value })}
                                            required
                                        />
                                        <label htmlFor="amount">Amount</label>
                                        <ImSortAmountDesc />
                                    </div>
                                    <div className="input-row"></div>
                                </div>
                                <div className="form-row">
                                    <div className="input-row">
                                        <input
                                            type="text"
                                            name="description"
                                            maxLength={50}
                                            value={transferData?.description}
                                            onChange={e => setTransferData({ ...transferData, description: e.target.value })}
                                            required
                                        />
                                        <label htmlFor="description">Description</label>
                                        <MdOutlineDescription />
                                    </div>
                                </div>
                                {
                                    transferData.domicile === 'international' && (
                                        <div className="form-row">
                                            <div className="input-row">
                                                <input
                                                    type="text"
                                                    name="swift"
                                                    value={transferData?.swift}
                                                    onChange={e => setTransferData({ ...transferData, swift: e.target.value })}
                                                    required
                                                />
                                                <label htmlFor="swift">Swift Code</label>
                                                <SiCodenewbie />
                                            </div>
                                            <div className="input-row">
                                                <input
                                                    type="text"
                                                    name="routing"
                                                    value={transferData?.routing}
                                                    onChange={e => setTransferData({ ...transferData, routing: e.target.value })}
                                                    required
                                                />
                                                <label htmlFor="routing">Routing Number</label>
                                                <SiCodenewbie />
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        )
                    }
                    {
                        activeFormPart === 2 && (
                            <div className="form-part personal-data">
                                <div className="form-row input-row not-required">
                                    <input type="text" name='otp' id='secure_pin' defaultValue={input} readOnly />
                                    <label htmlFor="secure_pin">Security PIN</label>
                                    <GiKeyLock />
                                </div>
                                <div className="form-row digit-btns">
                                    <div className="buttons">
                                        {
                                            buttons.map((button, index) => <div key={index} className='button'>{button}</div>)
                                        }
                                    </div>
                                    <div className="controls">
                                        <div className="control"><MdOutlineKeyboardBackspace onClick={() => setInput(input.slice(0, input.length - 1))} /></div>
                                        <div className="control"><MdClear onClick={() => setInput('')} /></div>
                                        <div className="control"><BiSend onClick={goForward} /></div>
                                    </div>
                                </div>
                            </div>
                        )
                    }
                    {
                        txCodes.length > 0 && (
                            txCodes.map((txCode, index) => (
                                activeFormPart === index + 3 && (
                                    <div className="form-part personal-data">
                                        <div className="form-row input-row not-required">
                                            <input type="text" name="otp" id={txCode.cid} defaultValue={input} readOnly />
                                            <label htmlFor={txCode.cid}>{txCode.code_name}</label>
                                            <GiKeyLock />
                                        </div>
                                        <div className="form-row digit-btns">
                                            <div className="buttons">
                                                {
                                                    buttons.map((button, index) => <div key={index} className='button'>{button}</div>)
                                                }
                                            </div>
                                            <div className="controls">
                                                <div className="control"><MdOutlineKeyboardBackspace onClick={() => setInput(input.slice(0, input.length - 1))} /></div>
                                                <div className="control"><MdClear onClick={() => setInput('')} /></div>
                                                <div className="control"><BiSend onClick={goForward} /></div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            ))
                        )
                    }
                    {
                        activeFormPart === 1 ? (
                            <div className="btn-row">
                                <div className="form-btn-column">
                                    <button type='button' onClick={goForward}>Send <FiSend /> </button>
                                </div>
                            </div>
                        ) : (
                            <div className="btn-row split-row">
                                <div className="left-column">
                                    <button type='button' onClick={() => setActiveFormPart(activeFormPart - 1)}><TbArrowBackUp /> Back</button>
                                    <strong onClick={clearForm}>cancel <MdOutlineClear /></strong>
                                </div>
                                <div className="right-column">
                                    <button type='button' onClick={goForward}>Validate <FiSend /> </button>
                                </div>
                            </div>
                        )
                    }
                </form>
            </div>
            <Info />
        </div>
    )
}

export default Transfer
